import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class PlaylistProvider extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'PlaylistProvider' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    playlist_name_template: string;

    @JsonProperty({ type: 'string?' })
    image_template_url?: string;
}



// WEBPACK FOOTER //
// ./src/api/src/models/playlist_provider.ts